<svelte:head>
<!--	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.46/dist/themes/base.css">-->
<!--	<script type="module" src="https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.46/dist/shoelace.js"></script>-->
	<link rel="preload" as="image" href="/img/livingroom_morning.png">
	<link rel="preload" as="image" href="/img/livingroom_noon.png">
	<link rel="preload" as="image" href="/img/livingroom_night.png">
</svelte:head>
<script>
	import dateFormat from 'dateformat';
	import {
		health, energy, hygiene, culture,
		iq, loneliness, confidence, stress,
		alcoholism, drugs, smooth,
		honesty, optimism, fitness,
		money, time, date,
		TimeEnum, TimeToPrint,
		upcomingEvent, Action,
		energy_geq_90, iq_geq_99,
		modal,
		startDate,
		currentJob,
		sleep, progressTime, anyEventsOn, getEventsOn, anyFutureEventsOn, days_skipped_work, turns_exhausted, died,
		turnCount
	} from './stores.js';
	import jobs from './jobs.js';
	import AloneActionsList from './AloneActionsList.svelte'
	import Action_Job from './Action_Job.svelte'
	import ItemsList from "./ItemsList.svelte";
	import Modal from './Modal.svelte'

	function getNextDay(day) {
		var next_day = new Date(day);
		next_day.setDate(next_day.getDate() + 1);
		return next_day;
	}

	function generateCalendar(date_0) {
		var date_1 = getNextDay(date_0);
		var date_2 = getNextDay(date_1);
		var date_3 = getNextDay(date_2);
		var date_4 = getNextDay(date_3);
		var date_5 = getNextDay(date_4);
		return [date_0, date_1, date_2, date_3, date_4, date_5];
	}

	import StatsBar from './StatsBar.svelte';
	import Grid from "svelte-grid";
	import gridHelp from "svelte-grid/build/helper/index.mjs";
	import BouncyBtn from "./BouncyBtn.svelte";
	import Career from "./Career.svelte";
	import Button from "./Button.svelte";
	import ActionLog from "./ActionLog.svelte";

	const COLS = 10;

	const remove = (item) => {
		windows = windows.filter((value) => value.id !== item.id);
	};

	function getItemById(id, items) {
		return items.find((value) => value.id === id);
	}

	function isWindowOpen(id) {
		return getItemById(id, windows) !== undefined;
	}

	function openAloneActions() {
		if (isWindowOpen('alone-actions')) {
			remove(getItemById('alone-actions', windows))
			return;
		}
		let newItem = {
			[COLS]: gridHelp.item({
				x: 6,
				y: 1,
				w: 3,
				h: 6,
				customDragger: true,
			}),
			id: "alone-actions",
		};

		let findOutPosition = gridHelp.findSpace(newItem, windows, COLS);

		newItem = {
			...newItem,
			[COLS]: {
				...newItem[COLS],
				...findOutPosition,
			},
		};

		windows = [...windows, ...[newItem]];
	}

	function openCareer() {
		if (isWindowOpen('career')) {
			remove(getItemById('career', windows))
			return;
		}
		let newItem = {
			[COLS]: gridHelp.item({
				x: 3,
				y: 3,
				w: 3,
				h: 3,
				customDragger: true,
			}),
			id: "career",
		};

		let findOutPosition = gridHelp.findSpace(newItem, windows, COLS);

		newItem = {
			...newItem,
			[COLS]: {
				...newItem[COLS],
				...findOutPosition,
			},
		};

		windows = [...windows, ...[newItem]];
	}

	let windows = [
		{
			[COLS]: gridHelp.item({
				x: 0,
				y: 0,
				w: 2,
				h: 5,
				resizable: false,
				customDragger: true,
			}),
			id: "stats",
		},
		{
			[COLS]: gridHelp.item({
				x: 4,
				y: 1,
				w: 3,
				h: 6,
				customDragger: true,
			}),
			id: "alone-actions",
		},
		{
			[COLS]: gridHelp.item({
				x: 0,
				y: 5,
				w: 2,
				h: 2,
				customDragger: true,
			}),
			id: "inventory",
		},
	];

	const cols = [[1800, COLS]];

	let background_class = '';
	$: switch ($time) {
		case TimeEnum.morning: background_class = 'home-morning'; break;
		case TimeEnum.evening: background_class = 'home-evening'; break;
		case TimeEnum.night: background_class = 'home-night'; break;
	}
</script>


<main class="{$died ? 'graveyard' : background_class}">

	<div class="time-money">
		<container>
			<time>
				<time-time>{TimeToPrint[$time]}</time-time>
				<time-date>{$date.toDateString()}</time-date>
			</time>
			<money>
				<sl-icon src="/img/coin.svg"></sl-icon> {$money.toFixed(2)}
			</money>
			<calendar>
				{#each generateCalendar($date) as day}
					<sl-tag type="{(day.getDay() === 0) || (day.getDay() === 6) ? 'success' : 'info'}">
						<div class="date-row">{dateFormat(day, "ddd")}</div>
						<div class="date-row">{dateFormat(day, "d. mmm")}</div>
						{#if anyFutureEventsOn(day, $time, $upcomingEvent)}
							<div class="badge-pulse calendar-mark">
								<sl-tooltip placement="bottom">
									<div slot="content">
										{#each getEventsOn(day, $upcomingEvent) as event}
											{event.name}<br>
										{/each}
									</div>
									<sl-badge type="danger" pill pulse>!</sl-badge>
								</sl-tooltip>
							</div>
						{/if}
					</sl-tag>
				{/each}
			</calendar>
		</container>
	</div>

	<div class=windows-container>
		{#if !$died}
		<Grid bind:items={windows} rowHeight={120} let:item let:dataItem {cols} let:movePointerDown>
			<div class=window>
			{#if item.customDragger}
				<div class=dragger on:pointerdown={movePointerDown}>
					✥ <small>{dataItem.id}</small>
				</div>
			{/if}
			{#if dataItem.id === "stats"}
				<div>
				<StatsBar name='Health' value={$health} tick={$turnCount} />
				<StatsBar name='Energy' value={$energy} tick={$turnCount} />
				<StatsBar name='Hygiene' value={$hygiene} tick={$turnCount} />
				<StatsBar name='Culture' value={$culture} tick={$turnCount} />
				<StatsBar name='IQ' value={$iq} tick={$turnCount} />
				<StatsBar name='Loneliness' value={$loneliness} tick={$turnCount} />
				<StatsBar name='Confidence' value={$confidence} tick={$turnCount} />
				<StatsBar name='Stress' value={$stress} tick={$turnCount} />
				<StatsBar name='Alcoholism' value={$alcoholism} tick={$turnCount} />
				<StatsBar name='Drugs' value={$drugs} tick={$turnCount} />
				<StatsBar name='Smooth' value={$smooth} tick={$turnCount} />
				<StatsBar name='Honesty' value={$honesty} tick={$turnCount} />
				<StatsBar name='Optimism' value={$optimism} tick={$turnCount} />
				<StatsBar name='Fitness' value={$fitness} tick={$turnCount} />
				</div>
			{:else if dataItem.id === "alone-actions"}
				<span on:pointerdown={e => e.stopPropagation()}
					  on:click={() => remove(dataItem)}
					  class=remove
				>
				✕
			  	</span>
				<div class="actions-list">
					<AloneActionsList />
				</div>
			{:else if dataItem.id === "career"}
				<span on:pointerdown={e => e.stopPropagation()}
					  on:click={() => remove(dataItem)}
					  class=remove
				>
				✕
			  	</span>
				<Career />
			{:else if dataItem.id === "inventory"}
				<inventory-grid>
					<ItemsList home={true} />
				</inventory-grid>
			{:else }
					{dataItem.id}
			{/if}
			</div>
		</Grid>

		<action-menu>
			<Button on:click={openAloneActions}>Activity</Button>
			<Button on:click={openCareer}>Career</Button>
			<Button on:click={() => modal.set(Action_Job)}
					disabled={!jobs.JobCategoryTimes($currentJob.category).includes($time)}>
				Work
			</Button>

			<Button on:click={sleep}
					disabled={($time !== TimeEnum.night) && ($energy >= 0.25)}
					tooltip="You can sleep only at night or when you are exhausted (Energy < 25)">
				Sleep
			</Button>
		</action-menu>

		<ActionLog />
		{/if}
		<Modal show={$modal}>
		</Modal>
	</div>
</main>

<style>
	main {
		margin: 0 auto;
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 0 1em 0 1em;
	}
	.home-morning {
		background: url("/img/livingroom_morning.png") center no-repeat;
		background-size: cover;
	}
	.home-evening {
		background: url("/img/livingroom_noon.png") center no-repeat;
		background-size: cover;
	}
	.home-night {
		background: url("/img/livingroom_night.png") center no-repeat;
		background-size: cover;
	}
	.graveyard {
		background: url("/img/graveyard.gif") center no-repeat;
		background-size: cover;
	}

	action-menu {
		position: fixed;
		left: 50%;
		bottom: 0px;
		transform: translate(-50%, -50%);
		margin: 0 auto;
		display: flex;
	}

	.window {
		background:rgba(255,255,255,0.85);

		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
	}

	.windows-container {
		max-width: 1400px;
		width: 100%;
		margin-top: 4em;
	}

	.actions-list {
		overflow-y: scroll;
		height: calc(100% - 2em);
		width: 100%;
		margin-top: 2em;
	}

	.time-money {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		text-align: center;
		display: flex;
		justify-content: center;
		height: 4em;
	}
	.time-money container {
		background:rgba(255,255,255,0.85);
		padding: 0 0.5em 0 0.5em;

		border-radius: 0 0 0.5em 0.5em;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-between;
	}
	.time-money time {
		flex-shrink: 2;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;

		min-width: 7.5em;

		padding: 0.3em;
		color: red;
		background-color: black;
		border-radius:10px;
	}
	.time-money time time-time{
		font-size: 1em;
		font-family: monospace;
	}
	.time-money time time-date{
		font-size: 0.7em;
	}
	.time-money money {
		flex-shrink: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.4em;
		color: darkorange;

		min-width: 7em;
	}
	.time-money calendar {
		flex-shrink: 4;
		display: flex;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: center;
	}
	.time-money calendar sl-tag {
		width: 4em;
		min-width: 4em;
		max-width: 4em;
		margin: 0.1em;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
	}
	.time-money calendar sl-tag div {
		line-height: 1.1em;
		padding: 0em;
	}

	.dragger {
		font-size: 1.3em;
		cursor: pointer;
		position: absolute;
		top: 1px;
		left: 1px;
		user-select: none;

		line-height: 30px;
		text-align: left;
		height: 30px;
		width: 100%;
		padding: 0 0 0 0.4em;
		z-index: 1;
	}
	.remove {
		font-size: 1.5em;
		cursor: pointer;
		position: absolute;
		right: 0.8em;
		top: 1px;
		user-select: none;
		z-index: 1;
	}

	.calendar-mark {
		position: absolute;
		bottom: -3px;
		right: -3px;
		z-index: 1;
	}

	inventory-grid {
		display: flex;
		padding: 0.6em;
		flex-wrap: wrap;
		width: 100%;
		justify-content: space-between;
		align-items: center;
	}
</style>